import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration/shared.config';
import { UtilityService } from './utility.service';

const BASE_URL = Configuration.adminApiUrl;
@Injectable()
export class AuthenticationService {

  private token;
  private user: any = {};
  isLoggedIn = false;
  get username() {
    return this.user && this.user.name;
  }

  constructor(
    private http: HttpClient,
    private util: UtilityService,
  ) {
    this.token = localStorage.getItem('token');
    try {
      this.user = JSON.parse(localStorage.getItem('user'));
    } catch (er) {
      this.user = {};
    }
  }

  public getToken(): string {
    return this.token;
  }

  isAuthenticated() {
    if (!this.token) {
      return Promise.reject(false);
    }

    return this.http.get(`${BASE_URL}/api/v1/admin/verify`)
      .toPromise()
      .then(res => {
        this.isLoggedIn = true;
        return res;
      })
      .catch(() => {
        this.logout();
        return Promise.reject(false);
      });
  }

  logout() {
    this.isLoggedIn = false;
    this.token = '';
    this.user = {};
    this.persistLogin();
    this.util.navigateToLoginPage();
  }

  getUser() {
    return this.user;
  }

  saveLogin(login) {
    this.token = login.token;
    this.user = login.data;
    this.isLoggedIn = true;

    this.persistLogin();
  }

  persistLogin() {
    localStorage.setItem('token', this.token);
    localStorage.setItem('user', JSON.stringify(this.user));
  }
}
